import { render } from "./Data.vue?vue&type=template&id=1980ca97&scoped=true&ts=true"
import script from "./Data.vue?vue&type=script&lang=ts"
export * from "./Data.vue?vue&type=script&lang=ts"

import "./Data.vue?vue&type=style&index=0&id=1980ca97&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1980ca97"]])

export default __exports__